import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public companyLogo = environment.companyLogo;
  public facebook = environment.facebook;
  public linkedin = environment.linkedin;
  public copyright = environment.copyright;

  constructor() { }

  ngOnInit(): void {
  }

}
